<mf-order-prospectus-form [dialogRefInput]='dialogRef' [inputData]='data'></mf-order-prospectus-form>